<div class="container-fluid">
    <div class="container-xxxl disease-page-top-element-padding">
        <div class="row pt-3">
            <div class="col">
                <div class="container-fluid pb-32">
                    <div class="row">
                        <h2 class="section-heading text-blue border-blue">Disease Information</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="row py-lg-5">
            <div class="col-12 col-xl-6 left-side">
                <app-disease-at-a-glance-summary></app-disease-at-a-glance-summary>
            </div>

            <div class="col-12 col-xl-6 right-side d-print-none">
                <disease-at-a-glance-snippets></disease-at-a-glance-snippets>
            </div>
        </div>
    </div>
</div>
